// @owners { team: patients }
export const ALL_ACTIVE_RXS = 'All active Rx on file';
